import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_create_api_key",
  ref: "createAPIKeyModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_create_api_key_header"
}
const _hoisted_5 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_8 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_create_api_key_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_create_api_key_header",
  "data-kt-scroll-wrappers": "#kt_modal_create_api_key_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_9 = {
  key: 0,
  class: "notice d-flex bg-light-warning rounded border-warning border border-dashed mb-10 p-6"
}
const _hoisted_10 = { class: "svg-icon svg-icon-2tx svg-icon-warning me-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack flex-grow-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "text-gray-800 fw-bolder" }, "Please Note!"),
    /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-gray-600" }, [
      /*#__PURE__*/_createTextVNode(" Adding new API key may afftect to your "),
      /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Affiliate Income")
    ])
  ])
], -1)
const _hoisted_12 = { class: "d-flex justify-content-center mt-5" }
const _hoisted_13 = ["src", "alt", "onClick"]
const _hoisted_14 = {
  key: 1,
  class: "mb-5 fv-row"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Kullanıcı Adı", -1)
const _hoisted_16 = { class: "fv-plugins-message-container" }
const _hoisted_17 = { class: "fv-help-block mt-9 mt-6 mt-4" }
const _hoisted_18 = {
  key: 2,
  class: "mb-5 fv-row"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Satıcı Id", -1)
const _hoisted_20 = { class: "fv-plugins-message-container" }
const _hoisted_21 = { class: "fv-help-block mt-9 mt-6 mt-4" }
const _hoisted_22 = {
  key: 3,
  class: "mb-5 fv-row"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Api Key", -1)
const _hoisted_24 = { class: "fv-plugins-message-container" }
const _hoisted_25 = { class: "fv-help-block mt-9 mt-6 mt-4" }
const _hoisted_26 = {
  key: 4,
  class: "mb-5 fv-row"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Api Secret", -1)
const _hoisted_28 = { class: "fv-plugins-message-container" }
const _hoisted_29 = { class: "fv-help-block mt-9 mt-6 mt-4" }
const _hoisted_30 = {
  key: 5,
  class: "d-flex flex-column mb-5 fv-row"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Parola", -1)
const _hoisted_32 = { class: "fv-plugins-message-container" }
const _hoisted_33 = { class: "fv-help-block mt-9 mt-6 mt-4" }
const _hoisted_34 = {
  key: 6,
  class: "mb-8"
}
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Doğrulama Kodu", -1)
const _hoisted_38 = { class: "fs-7 fw-bold text-gray-400 mb-3" }
const _hoisted_39 = {
  key: 7,
  class: "mb-8"
}
const _hoisted_40 = {
  key: 8,
  class: "d-flex flex-column mb-10 fv-row"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Şube", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("option", null, "Şube Seçiniz", -1)
const _hoisted_43 = ["value"]
const _hoisted_44 = { class: "fv-plugins-message-container" }
const _hoisted_45 = { class: "fv-help-block mt-9 mt-6 mt-4" }
const _hoisted_46 = {
  key: 9,
  class: "mb-10"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-5 fw-bold" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Menü"),
    /*#__PURE__*/_createElementVNode("i", {
      class: "fas fa-exclamation-circle ms-2 fs-7",
      "data-bs-toggle": "tooltip",
      title: "Seçili olan menü ürünleri sistemde görünecektir."
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "fs-7 fw-bold text-gray-400" }, " Seçili olan menü ürünleri ile işlem yapılacaktır ")
], -1)
const _hoisted_48 = { class: "fv-row" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("option", null, "Menü Seçiniz", -1)
const _hoisted_50 = ["value"]
const _hoisted_51 = { class: "fv-plugins-message-container" }
const _hoisted_52 = { class: "fv-help-block mt-9 mt-6 mt-4" }
const _hoisted_53 = { class: "modal-footer flex-center" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("button", {
  type: "reset",
  id: "kt_modal_create_api_key_cancel",
  class: "btn btn-white me-3"
}, " İptal Et ", -1)
const _hoisted_55 = {
  ref: "submitButtonRef",
  type: "submit",
  id: "kt_modal_create_api_key_submit",
  class: "btn btn-primary"
}
const _hoisted_56 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Kaydet ", -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Lütfen Bekleyin... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_58 = [
  _hoisted_56,
  _hoisted_57
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", null, "Entegrasyonu " + _toDisplayString(_ctx.apiData?.isNew? "Ekle":"Düzenle"), 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        (_ctx.apiData )
          ? (_openBlock(), _createBlock(_component_Form, {
              key: 0,
              id: "kt_modal_create_api_key_form",
              class: "form",
              onSubmit: _ctx.submit,
              "validation-schema": _ctx.validationSchema
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    false
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createElementVNode("span", _hoisted_10, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen044.svg" })
                          ]),
                          _hoisted_11
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_12, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.range(5), (index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "integrationItem",
                          key: index,
                          style: _normalizeStyle(_ctx.apiData?.integrationType == index ? 'border:1px dashed black' : '')
                        }, [
                          _createElementVNode("img", {
                            src: `media/integrations/${index}${_ctx.apiData?.integrationType == index ? '' : '-gray'}.png`,
                            alt: _ctx.IntegrationType[index],
                            width: "100",
                            height: "100",
                            onClick: ($event: any) => (_ctx.changeIntegrationType(index))
                          }, null, 8, _hoisted_13),
                          _createElementVNode("span", null, _toDisplayString(_ctx.IntegrationType[index]), 1)
                        ], 4))
                      }), 128))
                    ]),
                    (_ctx.apiData?.credentials && _ctx.apiData?.integrationType != _ctx.IntegrationType.Trendyol)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _hoisted_15,
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "Platforma girerken kullandığınız kullanıcı adı",
                            name: "userName",
                            modelValue: _ctx.apiData.credentials.username,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.apiData.credentials.username) = $event))
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, [
                              _createVNode(_component_ErrorMessage, { name: "userName" })
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.apiData?.credentials && _ctx.apiData?.integrationType == _ctx.IntegrationType.Trendyol)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _hoisted_19,
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "Entegrasyon bilgileri ekranındaki numerik değer",
                            name: "supplierId",
                            modelValue: _ctx.apiData.credentials.supplierId,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.apiData.credentials.supplierId) = $event))
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                              _createVNode(_component_ErrorMessage, { name: "supplierId" })
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.apiData?.credentials && _ctx.apiData?.integrationType == _ctx.IntegrationType.Trendyol)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _hoisted_23,
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "Entegrasyon bilgileri ekranındaki numerik değer",
                            name: "apiKey",
                            modelValue: _ctx.apiData.credentials.apiKey,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.apiData.credentials.apiKey) = $event))
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                              _createVNode(_component_ErrorMessage, { name: "apiKey" })
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.apiData?.credentials && _ctx.apiData?.integrationType == _ctx.IntegrationType.Trendyol)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                          _hoisted_27,
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "Entegrasyon bilgileri ekranındaki numerik değer",
                            name: "apiSecret",
                            modelValue: _ctx.apiData.credentials.apiSecret,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.apiData.credentials.apiSecret) = $event))
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                              _createVNode(_component_ErrorMessage, { name: "apiSecret" })
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.apiData?.credentials && _ctx.apiData?.integrationType != _ctx.IntegrationType.Trendyol)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                          _hoisted_31,
                          _createVNode(_component_Field, {
                            type: "password",
                            class: "form-control form-control-solid",
                            rows: "3",
                            name: "password",
                            modelValue: _ctx.apiData.credentials.password,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.apiData.credentials.password) = $event))
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("div", _hoisted_33, [
                              _createVNode(_component_ErrorMessage, { name: "password" })
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.apiData.integrationType == _ctx.IntegrationType.YemekSepeti && _ctx.apiData?.credentials?.username && _ctx.apiData?.credentials?.password && !_ctx.apiData.branches)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                          (!_ctx.ysOtpRequired)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-light-primary w-100",
                                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.connectYemeksepeti && _ctx.connectYemeksepeti(...args)))
                                }, " Bağlan / Doğrulama Kodu Gönder ")
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                _hoisted_37,
                                _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.ysChannelValue) + " adresine gönderilen kodu giriniz. ", 1),
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.ysOtpCode) = $event)),
                                  type: "text",
                                  inputmode: "numeric",
                                  class: "form-control form-control-solid mb-3",
                                  placeholder: "Doğrulama kodu",
                                  autocomplete: "one-time-code"
                                }, null, 512), [
                                  [_vModelText, _ctx.ysOtpCode]
                                ]),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-primary w-100",
                                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.verifyOtpModal && _ctx.verifyOtpModal(...args)))
                                }, " Doğrula ")
                              ]))
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.apiData.integrationType != _ctx.IntegrationType.YemekSepeti && !_ctx.apiData.branches && _ctx.canFetchBranches)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-light-primary w-100",
                            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.updateBranches && _ctx.updateBranches(...args)))
                          }, " Bağlan / Şubeleri Getir ")
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.apiData.branches)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                          _hoisted_41,
                          _createVNode(_component_Field, {
                            name: "branch",
                            "data-control": "select2",
                            "data-hide-search": "true",
                            "data-placeholder": "Şube Seçiniz...",
                            class: "form-select form-select-solid",
                            as: "select",
                            modelValue: _ctx.apiData.credentials.selectedBranch,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.apiData.credentials.selectedBranch) = $event))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_42,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.apiData.branches, (item) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: item,
                                  value: item.Id
                                }, _toDisplayString(item.Name) + " " + _toDisplayString(_ctx.apiData.integrationType == _ctx.IntegrationType.Trendyol ? `(${item.Id})` : ""), 9, _hoisted_43))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_44, [
                            _createElementVNode("div", _hoisted_45, [
                              _createVNode(_component_ErrorMessage, { name: "branch" })
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.apiData.integrationType == _ctx.IntegrationType.YemekSepeti && _ctx.apiData.branches && _ctx.apiData.credentials.selectedBranch && _ctx.apiData.branches.find(b => b.Id == _ctx.apiData.credentials?.selectedBranch)?.Menus)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                          _hoisted_47,
                          _createElementVNode("div", _hoisted_48, [
                            _createVNode(_component_Field, {
                              name: "menu",
                              "data-control": "select2",
                              "data-hide-search": "true",
                              "data-placeholder": "Bir Menü Seçiniz...",
                              class: "form-select form-select-solid",
                              as: "select",
                              modelValue: _ctx.apiData.credentials.selectedMenuId,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.apiData.credentials.selectedMenuId) = $event))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_49,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.apiData.branches.find(b => b.Id == _ctx.apiData.credentials?.selectedBranch).Menus, (item) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: item,
                                    value: item.id
                                  }, _toDisplayString(item.title.tr_TR), 9, _hoisted_50))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_51, [
                              _createElementVNode("div", _hoisted_52, [
                                _createVNode(_component_ErrorMessage, { name: "menu" })
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _hoisted_54,
                  _createElementVNode("button", _hoisted_55, _hoisted_58, 512)
                ])
              ]),
              _: 1
            }, 8, ["onSubmit", "validation-schema"]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 512))
}